import { client } from "../client";
import { AO_HOST } from "./aoHost";
import { request } from "../services/request.js";

/**
 * Fallback when no backgrounds.json manifest exists: parse the Apache
 * directory index of base/background/. A browser can't read a remote folder
 * directly, but if mod_autoindex serves a listing for that path, the folder
 * names appear as directory links (href="Name/") we can extract. Returns the
 * sorted folder names, or null if the listing isn't available/parseable.
 */
const listBackgroundsFromAutoindex = async (): Promise<string[] | null> => {
  try {
    const html = await request(`${AO_HOST}background/`);
    const names: string[] = [];
    // Directory entries end in "/". Sort-header and query links contain "?"
    // (excluded), and files have no trailing slash (excluded).
    const re = /href="([^"?]+)\/"/gi;
    let m: RegExpExecArray | null;
    while ((m = re.exec(html)) !== null) {
      const name = decodeURIComponent(m[1]).replace(/\/+$/, "");
      if (!name || name === ".." || name.startsWith("/") || name.includes("://")) {
        continue;
      }
      names.push(name);
    }
    return names.length ? names.sort((a, b) => a.localeCompare(b)) : null;
  } catch {
    return null;
  }
};

export const fetchBackgroundList = async () => {
  const bg_select = <HTMLSelectElement>document.getElementById("bg_select");
  let bg_array: string[] | null = null;
  try {
    const bgdata = await request(`${AO_HOST}backgrounds.json`);
    bg_array = JSON.parse(bgdata);
  } catch (err) {
    // No manifest -- try the live directory listing instead.
    bg_array = await listBackgroundsFromAutoindex();
  }

  if (!bg_array || bg_array.length === 0) {
    console.warn("no backgrounds.json manifest and no directory index to parse");
    return;
  }

  bg_select.innerHTML = "";
  bg_select.add(new Option("Custom", "0"));
  bg_array.forEach((background: string) => {
    bg_select.add(new Option(background));
  });
};

export const fetchCharacterList = async () => {
  const char_select = <HTMLSelectElement>(
    document.getElementById("client_iniselect")
  );
  char_select.innerHTML = "";

  char_select.add(new Option("Custom", "0"));

  try {
    const chardata = await request(`${AO_HOST}characters.json`);
    const char_array = JSON.parse(chardata);
    // the try catch will fail before here when there is no file

    char_array.forEach((character: string) => {
      char_select.add(new Option(character));
    });
  } catch (err) {
    console.warn("there was no characters.json file");
  }
};

export const fetchEvidenceList = async () => {
  const evi_select = <HTMLSelectElement>document.getElementById("evi_select");
  evi_select.innerHTML = "";

  evi_select.add(new Option("Custom", "0"));

  try {
    const evidata = await request(`${AO_HOST}evidence.json`);
    const evi_array = JSON.parse(evidata);
    evi_array.forEach((evi: string) => {
      evi_select.add(new Option(evi));
    });
  } catch (err) {
    console.warn("there was no evidence.json file");
  }
};

export const fetchExtensions = async () => {
  try {
    const extensiondata = await request(`${AO_HOST}extensions.json`);
    const allextensions = JSON.parse(extensiondata);
    client.charicon_extensions = allextensions.charicon_extensions || [".png", ".webp"];
    client.emote_extensions = allextensions.emote_extensions || [".gif", ".png", ".apng", ".webp", ".webp.static"];
    client.emotions_extensions = allextensions.emotions_extensions || [".png", ".webp"];
    client.background_extensions = allextensions.background_extensions || [".webp", ".apng", ".gif", ".png"];
    console.log("charicons "+client.charicon_extensions)
    console.log("emotes "+client.emote_extensions)
    console.log("emotions "+client.emotions_extensions)
    console.log("backgrounds "+client.background_extensions)
  } catch (err) {
    console.warn("there was no extensions.json file");
  }
};
